import { spawn } from 'redux-saga/effects';

import { sagas as loginUrl } from './loginUrlModule';

export default function* sagas() {
	yield spawn(loginUrl);
}
